import { useMutation, useQueryClient } from "react-query";
import axios from "../axios";

type DeleteMultipleItemsBody = {
    itemId: (number | string)[];
};

const deleteMultipleItems = async (body: DeleteMultipleItemsBody) => {
    const response = await axios.post("/api/item-delete", body);
    return response.data;
};

export default function useDeleteMultipleItems() {
    const queryClient = useQueryClient();

    return useMutation(
        (body: DeleteMultipleItemsBody) => deleteMultipleItems(body),
        {
            onSuccess: () => {
                queryClient.invalidateQueries(["item"]);
            },
        },
    );
}
